import { render, staticRenderFns } from "./insertSaleInvoice.vue?vue&type=template&id=6b3b94f9"
import script from "./insertSaleInvoice.vue?vue&type=script&lang=js"
export * from "./insertSaleInvoice.vue?vue&type=script&lang=js"
import style0 from "./insertSaleInvoice.vue?vue&type=style&index=0&id=6b3b94f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports